


























































































import Vue from 'vue';
import Enterprise from '@/datatypes/enterprise';
import CustomerText from '@/components/billing/customer-text.vue';
import SubscriptionText from '@/components/billing/subscription-text.vue';

export default Vue.extend({
  props: {
    enterprise: {
      type: Enterprise,
    },
  },
  components: {
    CustomerText,
    SubscriptionText,
  },
  methods: {
    customerUrl() {
      const customerId = this.enterprise.owner.sCustomerId;

      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].customer(customerId);
    },

    subscriptionUrl(customerId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].customer(customerId);
    },
  },
});
